function getEnv(key: string) {
  return process.env[`REACT_APP_${key}`]
}

export const config = {
  gateway: {
    url: getEnv("GATEWAY_URL") || "http://localhost:4000",
  },
}
